<template>
  <div>
    <div class="content">
      <router-view></router-view>
    </div>
    <ScholarshipFooter />
  </div>
</template>

<script>
import ScholarshipFooter from './components/ScholarshipFooter'

export default {
  name: 'app',
  components:{
    ScholarshipFooter
  },
  data(){
    return {}
  },
  methods:{}
}
</script>

<style lang="scss">
// Headings
//Dark Aqua: #1B86B5;
//Medium Aqua: #27AAE1;
//Light Gray: #ededed;
//Medium Gray: #dcdcdc;
//Dark Gray: #666;
//Red: #E02221;
//Yellow: #F4D02E;
//Green: #59B200;
//Inactive Gray: #A9A9A9;
//Light Gray: #bdbdbd;

@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400&display=swap');

.content {
  min-height: calc(100vh - 125px);
}

.site-header {
  background-color: white;
  padding: .5em;
}

.top-logo {
  width: 40%;
  margin-right: 30%;
  margin-left: 30%;
}

body {
  font-family: 'Open Sans', sans-serif;
  background-color: #efefef;
}

H1, H2, H3, H4, label, H5 { font-family: 'Open Sans', sans-serif; }

.piedmont_charitable_foundation
{
	--primary-color: #417F3C;
	--primary-faded: #86AD85;
	--secondary-color: #28245F;
	--secondary-faded: #629EC4;

	H1 { color: var(--secondary-color); }

	H3 { color: var(--primary-color); }

	span
	{
	  color: black;
	}

	.btn-primary
	{
	  color: var(--primary-faded) !important;
	  border: 2px solid var(--primary-faded) !important;
	}

	.btn-primary:hover {
	  color: var(--primary-color) !important;
	  border: 2px solid var(--primary-color) !important;
	}

	.btn-primary:active {
	  color: var(--primary-color);
	  border: 2px solid var(--primary-color);
	}

	.nav-link {
	  color: white !important;
	  font-family: 'Open Sans', sans-serif;
	  font-size: 20px;
	  padding-left: 50px !important;
	}

	.nav-link:hover
	{
	  color: var(--secondary-color) !important;
	}

	.navbar
	{
	  background-color: var(--primary-faded);
	  width: 100%;
	  padding: 0;
	}

	.arrow_box:after
	{
	  border-left-color: var(--primary-faded);
	  border-width: 21px;
	  margin-top: -21px;
	}

	.arrow_box:before
	{
	  border-left-color: var(--primary-faded);
	  border-width: 24px;
	  margin-top: -24px;
	}

	// Active Menu item
	.active, .active a, .nav-left ul li:hover
	{
	  background-color: var(--primary-color);
	  color: white !important;
	  text-decoration: none;
	}

	.active .arrow_box:hover:after, .active .arrow_box:after, .active.arrow_box:after { border-left-color: var(--primary-color) !important;}

	.arrow_box:hover:after { border-left-color: var(--primary-color); }

	.nav-link:hover
	{
	  color: white !important;
	  background-color: var(--primary-color) !important;
	}

	// Active Menu item
	.active a, .nav-left ul li:hover
	{
	  color: white !important;
	  background-color: var(--primary-color) !important;
	  text-decoration: none;
	}

	.active
	{
	  color: white !important;
	  background-color: #a9a9a9 !important;
	}
}

.naval_intelligence_professionals
{
	--primary-color: #28245F;
	--secondary-color: #F8BB00;
	--primary-faded: #276890;
	--secondary-faded: #d6b44f;

	H1 { color: var(--secondary-color); }

	H3 { color: var(--primary-color); }

	span
	{
	  color: black;
	}

	.btn-primary
	{
	  color: var(--primary-faded) !important;
	  border: 2px solid var(--primary-faded) !important;
	}

	.btn-primary:hover {
	  color: var(--primary-color) !important;
	  border: 2px solid var(--primary-color) !important;
	}

	.btn-primary:active {
	  color: var(--primary-color);
	  border: 2px solid var(--primary-color);
	}

	.nav-link {
	  color: white !important;
	  font-family: 'Open Sans', sans-serif;
	  font-size: 20px;
	  padding-left: 50px !important;
	}

	.nav-link:hover
	{
	  color: var(--secondary-color) !important;
	}

	.navbar
	{
	  background-color: var(--primary-faded);
	  width: 100%;
	  padding: 0;
	}

	.arrow_box:after
	{
	  border-left-color: var(--primary-faded);
	  border-width: 21px;
	  margin-top: -21px;
	}

	.arrow_box:before
	{
	  border-left-color: var(--primary-faded);
	  border-width: 24px;
	  margin-top: -24px;
	}

	// Active Menu item
	.active a, .nav-left ul li:hover
	{
	  background-color: var(--primary-color);
	  color: white !important;
	  text-decoration: none;
	}

	.active .arrow_box:hover:after, .active .arrow_box:after, .active.arrow_box:after { border-left-color: var(--primary-color) !important;}

	.arrow_box:hover:after { border-left-color: var(--primary-color); }

	.nav-link:hover
	{
	  color: white !important;
	  background-color: var(--primary-color) !important;
	}

	// Active Menu item
	.active a, .nav-left ul li:hover
	{
	  color: white !important;
	  background-color: var(--primary-color) !important;
	  text-decoration: none;
	}

	.active
	{
	  color: white !important;
	  background-color: var(--primary-faded) !important;
	}
}

H1
{
	font-size: 30px;
	color: #9f9f9f;
	font-weight: 600;
}

H2
{
	font-size: 25px;
	color: #6f6f6f;
	font-weight: 600;
}

H3
{
	font-size: 22px;
	color: #5f5f5f;
	font-weight: 600;
}

// Links
a, a:link, a:visited { color: #27AAE1; }
a:hover { color: #1B86B5; }

// Header/Navbar
.header {
  height: 150px;
  background-color: white;
}

.navbar
{
	background-color: #fff;
	width: 100%;
	padding: 0;
}

.navbar .btn-primary
{
	position: absolute;
	right: 0;
	top: 2px;
}

// Colors - Header
.light-bg
{
  background-color: #ededed;
  border-bottom: 1px solid white;
}

.med-bg { background-color: white; }
.dark-bg, .nav-item:hover { 
  background-color: #cfcfcf;
}

.no-hover {
  pointer-events: none;
}

.notice
{
	color: #000;
	font-size: 25px;
	font-family: 'Open Sans', sans-serif;
	font-weight: 600;
}

// Menu items
.nav-link {
	color: #9f9f9f !important;
	font-family: 'Open Sans', sans-serif; 
	font-size: 20px;
	padding-left: 50px !important;
}

.nav-link:active {
	color: white !important;
}

.nav-link:hover {
  color: white !important;
}

.disabled { color: #a9a9a9 !important; }

// Menu arrows
.arrow_box
{
	position: relative;
}

.arrow_box:after, .arrow_box:before
{
	left: 100%;
	top: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
	z-index: 1000;
}

.arrow_box:after
{
	border-left-color: white;
	border-width: 21px;
	margin-top: -21px;
}

.arrow_box:before
{
	// border-color: rgba(194, 225, 245, 0);
	border-left-color: #efefef;
	border-width: 24px;
	margin-top: -24px;
}

// Active Menu item
.active, .active a, .nav-left ul li:hover
{
	background-color: #9f9f9f;
	color: white !important;
	text-decoration: none;
}

.active .arrow_box:hover:after, .active .arrow_box:after, .active.arrow_box:after { border-left-color: #9f9f9f !important;}

.arrow_box:hover:after { border-left-color: #cfcfcf; }

// Left column menu
.nav-left ul li
{
	margin-left: -40px;
	list-style-type: none;
	border-bottom: 1px solid #999;
}

.nav-left ul .side-nav-link, .progress-bar-container {
	padding: 10px;
}

.nav-left ul li a
{
	color: #666;
	font-weight: 600;
	width: 100%;
	display: block;
	padding: 10px;
}

.nav-left ul li:last-child { border-bottom: none; }

.no-padding {
	padding: 0;
}

li a span {
	padding: 10px;
}



// Red alert triangle
.triangle
{
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 13px 23.3px 13px;
	border-color: transparent transparent #e02121 transparent;
	color: #fff;
	font-weight: 600;
}

// For positioning red alert triangle in menu
.tri-nav-err
{
	position: absolute;
	right: 0;
	top: -18px;
}

.nav-left .tri-nav-err
{
	position: relative;
	top: -25px;
	right: 8px;
}

// Number or ! inside triangle
.err-number
{
	display: block;
	width: 13px;
	margin-left: -6px;
	padding-top: 6px;
	text-align: center;
	font-size: 13px;
}

// Success checkmark in circle
.success-circle
{
	background-color: #59B200;
	border-radius: 15px;
	width: 25px;
	height: 25px;
}

.success-check
{
	display: block;
	width: 25px;
	color: #fff;
	padding-top: 1px;
	text-align: center;
}

// Colors
// Buttons
.btn-primary
{
  border: 2px solid #9f9f9f !important;
	font-family: 'Open Sans', sans-serif;
	font-size: 18px;
	color: #9f9f9f !important;
  background-color: rgba(0, 0, 0, 0) !important;
}

.btn-primary:hover {
  color: #6f6f6f !important;
  border: 2px solid #6f6f6f !important;
}

.btn-primary:active {
  color: #6f6f6f;
  border: 2px solid #6f6f6f;
}

.bg-secondary { background-color: #27AAE1 !important; }
a.bg-secondary:focus, a.bg-secondary:hover, button.bg-secondary:focus, button.bg-secondary:hover { background-color: #1B86B5 !important; }

input[type="submit"].bg-secondary:hover, input[type="submit"].bg-secondary:focus { background-color: #1B86B5 !important; }

// Alerts
.red { color: #E02221; }
.white { color: #fff; }

.progress
{
	height: 30px;
	border-radius: 20px;
	background-color: #fff;
	border: 1px solid #dcdcdc;
}

.progress-bar-success { background-color: #59B200; }

// Main
// Form elements
.form-control
{
	margin-bottom: 10px;
}

.form-control-label
{
	margin-right: 7px;
}

.radio-and-check-left
{
	margin-left: 2px;
}



label
{
	font-size: 20px;
	color: #666;
	font-weight: 600;
}

// Footer

.desktop-only {display: none;}
// MOBILE VIEWS

@media (max-width: 840px)
{
	.navbar-toggler
	{
		background-color: #cfcfcf;
		margin: 3px 3px 3px 8px;
	}

	.navbar-toggler:hover { background-color: #9f9f9f !important; }
	.nav-link { 
		margin-left: 0; 
		font-size: 80% !important;
	}

	.nav-item {
		background-color: white;
	}

	.collapse.in{
		display:block !important;
		float: left;
		width: 100%;
	}

	.tri-nav-err
	{
		top: 5px;
		right: 5px;
	}

	.mid-row { text-align: center; }

	.mobile-only {display: none;}

	.desktop-only {display: block !important;}

	.page-footer {
		font-size: .75em;
	}

	.taphere-logo {
		width: 30% !important;
		height: auto !important;
	}

	.footer-left {
		width: 50% !important;
		display: inline block;
		margin-top: 2em !important;
	}

	.footer-right {
		width: 50% !important;
		display: inline block;
	}

	.corner-logo {
		width: 40% !important;
		height: auto !important;
		margin-left: .5em !important;
	}

	.top-logo {
		width: 80% !important;
		height: auto !important;
		margin-right: 10% !important;
		margin-left: 10% !important;
	}

	.login-status {
		font-size: 60%;
	}

	.login-button {
		font-size: 60%;
		padding: 1em;
		margin-right: .5em !important;
	}

	.login-page {
		max-width: 100% !important;
	}

	.login-content {
		width: 90%;
		margin-right: 5% !important;
		margin-left: 5% !important;
	}

	.scholCard {
		width: 90% !important;
		margin-right: 5% !important;
		margin-left: 5% !important;
	}

	.modal {
		width: 90% !important;
		margin-right: 5% !important;
		margin-left: 5% !important;
	}

	.my-modal.show
	{
		opacity: 0.5 !important;
		background-color: red !important;
	}
}

.style-logo {
	height: 70px;
	width: auto;
}

.footer-logo {
	border: 0;
	height: auto;
	width: 150px;
}

a.login-link {
	color: #fff;
}

a.back-link {
	font-size: 1.3em;
}

// Chrome/Opera/Safari
input::-webkit-input-placeholder {
	color: #bdbdbd !important;
}

// Firefox 18 and earlier
input:-moz-placeholder {
	color: #bdbdbd !important;
}

// Firefox 19 and newer
input::-moz-placeholder {
	color: #bdbdbd !important;
}

// Internet Explorer
input:-ms-input-placeholder {
	color: #bdbdbd !important;
}

.login-label {
	display: block;
}

.login-error-style {
	color: #d8000c;
}

.logo-header {
  height: 150px;
  margin-top: 4em;
  border-radius: 5px 5px 0px 0px;
  background-color: #1B86B5;
  justify-content: center;
}

.centered-logo {
  max-height: 7em;
  margin-top: 2em;
}

.tagline {
  color: #bfbfbf;
  font-size: 1em;
}

.judge-portal-top {
	margin-top: 10px;
}

.top-card-spacing {
	top: 1.2em;
}

.btn-margin {
	margin-left: 12px;
}

.bg-grey {
	background-color: #6c757d;
	border-color: #6c757d;
}

.bg-grey:hover {
	background-color: #565d63;
}

//Form elements

textarea{
	max-width: 100%;
}

</style>
